const confirmUnsavedChanges = (isConfirmed: (props: any) => Promise<boolean>) =>
    isConfirmed({
        title: 'Are you sure you want to exit?',
        message: 'If you leave without saving, all changes you made will be lost.',
        cancelButton: { label: 'Stay on this page', color: 'primary' },
        acceptButton: { label: 'Exit and discard', color: '', outline: true },
        // staying is the primary action here, so it takes the rightmost position
        reverseButtons: true
    })

export { confirmUnsavedChanges }
